// Operasyon Yönetimi sayfası. Takvimin ortak metinleri profilePage.calendar
// altındadır (profil takvimiyle aynı bileşenler). Excel başlıkları ve kayıtlara
// yazılan değerler Türkçe kalır; burada yalnızca ekrandaki metinler var.
const operations = {
  title: 'Operasyon Yönetimi',
  subtitle: 'Çalışanların takvimleri, personel raporları ve SC takibi tek yerde.',
  report: {
    button: 'Detaylı Rapor',
    buttonHint: 'Tüm çalışanların vizit ve işlerini tarih aralığına göre Excel olarak indirin',
    title: 'Detaylı Rapor',
    subtitle: 'Rapor tarih aralığını seçin',
    start: 'Başlangıç Tarihi',
    end: 'Bitiş Tarihi',
    help: 'Rapor tüm çalışanların bu aralıktaki vizitlerini ve işlerini içerir: vizitler "Visitler", işler "İşler" sayfasında. Dosya Türkçe başlıklarla indirilir.',
    generate: 'Rapor Oluştur',
    generating: 'Hazırlanıyor...',
    cancel: 'İptal',
  },
  calendar: {
    title: 'Çalışan takvimi',
    employee: 'Çalışan',
    employeePlaceholder: 'Takvimini görmek için çalışan seçin...',
    noEmployees: 'Çalışan bulunamadı',
    pickTitle: 'Görüntülemek için bir çalışan seçin',
    pickText: 'Yukarıdaki "Çalışan" kutusundan bir çalışan seçtiğinizde vizitleri, işleri ve izinleri burada görünür.',
    lazyNote: 'Veriler, bir çalışan seçildiğinde yüklenir.',
    sameAsProfile: 'Bu takvim, çalışanın profilindeki takvimle aynı kayıtları aynı şekilde gösterir: her vizit penceresi boyunca bir çubuk, koyu kısım vizit günü, yeşil tik tamamlandığı gün. Bir kayda dokunarak açın; bir güne dokunarak o günün listesini görün.',
    loading: 'Takvim yükleniyor',
    loadingShort: 'Yükleniyor...',
    recordCounts: '{{visits}} vizit · {{jobs}} iş kayıtlı',
    refresh: 'Yenile',
    viewLabel: 'Takvim görünümü',
    views: {
      month: 'Ay',
      week: 'Hafta',
      day: 'Gün',
      list: 'Liste',
    },
    prev: {
      month: 'Önceki ay',
      week: 'Önceki hafta',
      day: 'Önceki gün',
      list: 'Önceki ay',
    },
    next: {
      month: 'Sonraki ay',
      week: 'Sonraki hafta',
      day: 'Sonraki gün',
      list: 'Sonraki ay',
    },
    summaryLabel: 'Görünen dönemin özeti',
    noEntries: 'Kayıt yok',
    openDay: 'Günü aç',
    openWindows_one: '{{count}} açık pencere',
    openWindows_other: '{{count}} açık pencere',
    emptyMonth: 'Bu ay için kayıt yok',
    emptyMonthHint: 'Önceki veya sonraki aya geçmeyi deneyin.',
  },
  job: {
    title: 'İş Detayları',
    status: 'Durum',
    employee: 'Çalışan',
    unknown: 'Belirtilmemiş',
    start: 'Başlangıç',
    end: 'Bitiş',
    time: 'Saat',
    description: 'Açıklama',
    markDone: 'Tamamlandı Olarak İşaretle',
    markOpen: 'Tamamlanmadı Olarak İşaretle',
    delete: 'Sil',
    deleteTitle: 'İş silinsin mi?',
    deleteMessage: '"{{title}}" işi kalıcı olarak silinecek.',
    cascade: 'Bu ve Sonraki İşleri Sil',
    cancel: 'Vazgeç',
  },
  cascade: {
    titleVisit: 'Ziyaret Serisini Sil',
    titleJob: 'İş Serisini Sil',
    warning: 'Aşağıdaki kayıtlar kalıcı olarak silinecek. Bu işlem geri alınamaz.',
    employee: 'Çalışan',
    unknown: 'Belirtilmemiş',
    patient: 'Hasta ID',
    jobTitle: 'İş Başlığı',
    from: 'Başlangıç tarihi',
    fromValue: '{{date}} ve sonrası',
    scanning: 'Kayıtlar taranıyor...',
    none: 'Silinecek kayıt bulunamadı.',
    count_one: 'Silinecek kayıt sayısı: {{count}}',
    count_other: 'Silinecek kayıt sayısı: {{count}}',
    selected: 'Seçilen',
    noProject: 'Proje Belirtilmemiş',
    visitNumber: 'Ziyaret No: {{n}}',
    days_one: '{{count}} gün',
    days_other: '{{count}} gün',
    done: 'Tamamlandı',
    ongoing: 'Devam Ediyor',
    cancel: 'Vazgeç',
    confirm_one: '{{count}} Kaydı Kalıcı Olarak Sil',
    confirm_other: '{{count}} Kaydı Kalıcı Olarak Sil',
    deleting: 'Siliniyor...',
  },
  personnel: {
    title: 'Personel Raporları',
    description: 'Tüm aktif çalışanların seçilen dönemdeki vizit ve işleri. Açtığınızda yüklenir.',
    activeEmployees_one: '{{count}} Aktif Çalışan',
    activeEmployees_other: '{{count}} Aktif Çalışan',
    loading: 'Tüm çalışanlar için veriler yükleniyor',
    period: 'Dönem',
    periods: {
      week: 'Bu Hafta',
      month: 'Bu Ay',
      year: 'Bu Yıl',
      custom: 'Özel',
    },
    customStart: 'Dönem başlangıcı',
    customEnd: 'Dönem bitişi',
    excel: 'Excel İndir',
    excelHint: 'Tablodaki (filtrelenmiş) çalışanları Excel olarak indir',
    summary: {
      totalVisits: 'Toplam Ziyaret',
      completedVisits: 'Tamamlanan Ziyaret',
      inProgressVisits: 'Devam Eden Ziyaret',
      totalJobs: 'Toplam İş',
      completedJobs: 'Tamamlanan İş',
      uniqueProjects: 'Proje',
    },
    topTitle: 'En Çok Ziyaret Yapanlar',
    visitsShort_one: '{{count}} ziyaret',
    visitsShort_other: '{{count}} ziyaret',
    rateShort: '%{{rate}} tamamlama',
    tableHelp: 'Bir başlığa dokunarak sıralayın. Sayı kutularına 5, >5, <5, >=5 veya <=5 yazarak süzün. Bir satıra dokunarak çalışanın vizit ve işlerini açın.',
    columns: {
      employeeName: 'Çalışan',
      totalVisits: 'Ziyaret',
      completedVisits: 'Tamamlanan Z.',
      totalJobs: 'İş',
      completedJobs: 'Tamamlanan İ.',
      projectsWorkedOn: 'Proje',
      completionRate: 'Başarı',
    },
    searchName: 'İsim ara...',
    example: 'Örn: {{value}}',
    filterLabel: '{{column}} filtresi',
    empty: 'Bu dönemde kayıt bulunan çalışan yok',
    openEmployee: '{{name}} ayrıntılarını aç',
    close: 'Kapat',
    successRate: 'Başarı',
    visitDetails_one: 'Ziyaret Detayları ({{count}})',
    visitDetails_other: 'Ziyaret Detayları ({{count}})',
    jobDetails_one: 'İş Detayları ({{count}})',
    jobDetails_other: 'İş Detayları ({{count}})',
    noVisits: 'Bu dönemde ziyaret bulunmuyor',
    noJobs: 'Bu dönemde iş bulunmuyor',
    noProject: 'Proje Belirtilmemiş',
    days_one: '{{count}} Gün',
    days_other: '{{count}} Gün',
    done: 'Tamamlandı',
    ongoing: 'Devam Ediyor',
  },
  sc: {
    title: 'SC Takip Tablosu',
    description: 'Saha koordinatörleri, backup personeli ve hemşirelerin proje ve merkez görevleri. Açtığınızda yüklenir.',
    badge: '{{sc}} SC · {{projects}} Proje',
    loading: 'Veriler yükleniyor',
    summary: {
      scPeople: 'SC Personel',
      projects: 'Proje',
      sites: 'Merkez',
      activePatients: 'Aktif Hasta',
    },
    search: 'SC, Proje, Merkez, PI ara...',
    roleFilter: 'Rol',
    roles: {
      all: 'Tüm Roller',
      sc: 'Saha Koordinatörü',
      backup: 'Backup Personeli',
      nurse: 'Hemşire',
      scSorumlusu: 'SC Sorumlusu',
    },
    statusFilter: 'Durum',
    statuses: {
      all: 'Tüm Durumlar',
      active: 'Aktif',
      inactive: 'Pasif',
    },
    refresh: 'Yenile',
    refreshHint: 'Verileri Yenile',
    clear: 'Temizle',
    clearHint: 'Filtreleri Temizle',
    excel: 'Excel İndir',
    active: 'Aktif',
    inactive: 'Pasif',
    groupCount_one: '{{count}} kayıt',
    groupCount_other: '{{count}} kayıt',
    columns: {
      scName: 'SC',
      employeeStatus: 'Durum',
      phone: 'Telefon',
      email: 'E-Posta',
      serviceFte: 'Hizmet-FTE',
      project: 'Proje',
      protocolNumber: 'Protokol',
      indication: 'Endikasyon',
      site: 'Merkez',
      pi: 'PI',
      delegation: 'Delegasyon',
      targetedPatients: 'Hedeflenen Hasta',
      screenedPatients: 'Screen Edilen',
      screenFailure: 'Screen Failure',
      randomization: 'Randomizasyon',
      currentPatients: 'Güncel Hasta',
      sponsor: 'Sponsor',
    },
    empty: 'Kayıt bulunamadı',
    footer: {
      count_one: 'Toplam {{count}} kayıt gösteriliyor',
      count_other: 'Toplam {{count}} kayıt gösteriliyor',
      filteredFrom: '({{total}} kayıttan filtrelendi)',
      grouped_one: '{{count}} SC altında gruplandı — proje veya merkeze göre sıralarsanız düz listeye döner',
      grouped_other: '{{count}} SC altında gruplandı — proje veya merkeze göre sıralarsanız düz listeye döner',
    },
    toast: {
      loaded: 'SC takip verileri başarıyla yüklendi',
      loadError: 'SC takip verileri yüklenirken hata oluştu',
      searchError: 'Arama sırasında bir hata oluştu',
      filterError: 'Tablo filtreleme sırasında bir hata oluştu',
      exported: 'Excel dosyası başarıyla indirildi',
    },
  },
  toast: {
    load: 'Veriler yüklenirken hata oluştu',
    loadAll: 'Tüm veriler yüklenirken hata oluştu',
    noData: 'İndirilecek veri bulunamadı',
    personnelExported: 'Personel raporu başarıyla indirildi!',
    exportError: 'Excel indirme sırasında hata oluştu',
    jobDone: 'İş tamamlandı olarak işaretlendi!',
    jobOpen: 'İş devam ediyor olarak işaretlendi!',
    jobUpdateError: 'İş durumu güncellenirken bir hata oluştu',
    jobDeleted: 'İş başarıyla silindi',
    jobDeleteError: 'İş silinirken bir hata oluştu',
    cascadeNoEmployee: 'Bu kayıtta çalışan bilgisi yok, seri silme yapılamaz',
    cascadeNoPatient: 'Bu ziyarette Hasta ID yok, seri silme yapılamaz',
    cascadeNoTitle: 'Bu işte başlık yok, seri silme yapılamaz',
    cascadeNoDate: 'Bu kaydın tarihi okunamadı, seri silme yapılamaz',
    cascadeListError: 'Silinecek kayıtlar listelenirken hata oluştu',
    mirrorError: 'Bazı eş vizitler silinemedi; unblinded çalışanın takvimini kontrol edin.',
    cascadeDeleted_one: '{{count}} kayıt silindi',
    cascadeDeleted_other: '{{count}} kayıt silindi',
    cascadeDeleteError: 'Kayıtlar silinirken bir hata oluştu',
    reportDates: 'Lütfen başlangıç ve bitiş tarihlerini seçin',
    reportDone: 'Detaylı rapor başarıyla oluşturuldu! ({{visits}} visit, {{jobs}} iş)',
    reportError: 'Rapor oluşturulurken hata oluştu',
  },
};

export default operations;
